export enum MlParam {
  plPeriod = 'plPeriod',
  plColumns = 'plColumns',
  plFeatures = 'plFeatures',
  plGroups = 'plGroups',
  analyseOption = 'analyseOption',
  ids = 'ids',
  scKpis = 'scKpis',
  scPeriod = 'scPeriod',
  tsDuration = 'tsDuration',
  tsSummary = 'tsSummary',
  sgSegment = 'sgSegment',
  sgPeriod = 'sgPeriod',
  customComparisonPeriod = 'customComparisonPeriod',
}

export enum LeaderboardParams {
  lbPeriod = 'lbPeriod',
  lbColumns = 'lbColumns',
  lbFeatures = 'lbFeatures',
  lbGroups = 'lbGroups',
  analyseOption = 'analyseOption',
}

export enum MiParam {
  customComparisonPeriod = 'customComparisonPeriod',
  grouping = 'grouping',
  tsDuration = 'tsDuration',
  tsSummary = 'tsSummary',
  sgPeriod = 'sgPeriod',
  sgSegment = 'sgSegment',
  scPeriod = 'scPeriod',
  scKpis = 'scKpis',
  ids = 'ids',
  customFeatureTiers = 'customFeatureTiers',
}

export const Page = {
  time: 'time',
  segmentation: 'segments',
  scorecard: 'scorecard',
  leaderboard: 'leaderboard',
  analyseLeaderboard: 'analyse_leaderboard',
  products: 'products',
  analyseProducts: 'analyse-products',
  overview: 'overview',
} as const;

export const DpPage = {
  products: 'dp-products',
  analyseProducts: 'dp-analyse-products',
  scorecard: 'dp-scorecard',
  segmentation: 'dp-segments',
  time: 'dp-time',
  leaderboard: 'dp-leaderboard',
  analyseLeaderboard: 'dp-analyse-leaderboard',
  overview: 'dp-overview',
} as const;

export enum ContentType {
  productLeaders = 'productLeaders',
  productsScorecard = 'productsScorecard',
  productsTimeSeries = 'productsTimeSeries',
  productsSegmentation = 'productsSegmentation',
  timeSeries = 'timeSeries',
  segmentation = 'segmentation',
  scorecard = 'scorecard',
  leaderboard = 'leaderboard',
}

export enum Category {
  brands = 'brands',
  prices = 'prices',
  channels = 'channels',
  features = 'features',
  productGroups = 'product-groups',
  countries = 'countries',
  regions = 'regions',
  firstActivity = 'first-activity',
}

export enum UiDataParams {
  uiEnrichments = 'uiEnrichments',
}

export const ContextName = {
  market: 'market',
  dp: 'distribution-panel',
} as const;
